'use client';

import classNames from 'classnames';
import { CheckboxState } from '@nx-frontend/shared/ui/checkbox';

interface UiCheckboxProps {
  id: string;
  checked: boolean;
  value: string;
  name: string;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  hasError?: boolean;
  overlayBgColor?: string;
  activeControlBorderColor?: string;
  activeControlBgColor?: string;
  className?: string;
}

export const Radio: React.FC<UiCheckboxProps> = ({
  id,
  value,
  checked,
  name,
  onChange,
  label,
  disabled,
  hasError,
  overlayBgColor = 'border-gray-400',
  activeControlBgColor = 'bg-teal-400',
  activeControlBorderColor = 'border-teal-400',
  className,
}) => {
  const handleChange = () => {
    onChange(!checked);
  };
  //TODO inport colot to theme settings
  const disabledBgColor = 'bg-gray-300';
  const disabledBorderColor = 'border-gray-300';
  const disabledTextColor = 'text-gray-300';
  const errorTextColor = 'text-red-500';
  const errorBgColor = 'bg-red-500';
  const defaultRadioStyle = 'w-4 h-4 border-2 rounded-full bg-white ';
  const getCheckboxStyles = (state: CheckboxState) => {
    const controlColor = disabled ? disabledBgColor : activeControlBorderColor;
    const borderColor = disabled ? disabledBorderColor : overlayBgColor;
    const styles = {
      [CheckboxState.UNCHECKED]: `${defaultRadioStyle} ${hasError ? 'border-red-500' : borderColor}`,
      [CheckboxState.CHECKED]: `${defaultRadioStyle} ${hasError ? 'border-red-500' : controlColor}`,
    };

    return styles[state];
  };

  const checkboxStyles = getCheckboxStyles(checked ? CheckboxState.CHECKED : CheckboxState.UNCHECKED);

  const checkboxClasses = classNames('w-2 h-2', {
    [errorBgColor]: hasError,
    [activeControlBgColor]: !hasError,
    'rounded-full': true,
  });

  const labelClasses = classNames('whitespace-nowrap cursor-pointer', {
    [disabledTextColor]: disabled,
    [errorTextColor]: hasError,
  });

  return (
    <div className={classNames('flex items-center w-full gap-2', className)}>
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        className="w-4 h-4 z-10 opacity-0 cursor-pointer"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      <div className={`flex items-center justify-center absolute transition duration-300 transform ${checkboxStyles}`}>
        {checked && <span className={checkboxClasses}></span>}
      </div>
      {label && (
        <label htmlFor={id} className={labelClasses}>
          {label}
        </label>
      )}
    </div>
  );
};
